import * as React from 'react'

import { Box, Icon, Table, Text } from '@factorialco/deprecated-design-system'
import {
  EmployeeCustomTablesSchemaFieldFragment,
  EmployeeCustomTablesSchemaFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import type Value from 'modules/custom_resources/store/models/customResources/Value'
import { getValue } from 'modules/employees/components/CustomResources/SchemaComponent/utils/getValue'
import { RouteContext } from 'modules/employees/pages/CustomTablesListPage/context'

interface Props {
  attachableId: number
  schema: EmployeeCustomTablesSchemaFragment
  value: Value
  currency: string
}

const TableBodyRowComponent = ({ schema, value, currency }: Props) => {
  const rootRoute = React.useContext(RouteContext)

  const {
    company: { locale: companyLocale },
  } = useCurrentSession()

  if (!rootRoute) return null

  const goToEdit = (valueId: number) => {
    return rootRoute.customTablesEdit(String(schema.id), String(valueId))
  }

  const itemValue = (currentValue: Value, field?: EmployeeCustomTablesSchemaFieldFragment | null) =>
    getValue({
      schemaEffectiveAtId: schema.effectiveAtId,
      field,
      currency,
      currentValue,
      companyLocale: companyLocale || '',
    })

  return (
    <Table.Row.Router to={goToEdit(value.attributes.id)}>
      {schema.fields.map((field, key) => (
        <Table.Cell key={key}>
          <Text.Normal size="300" weight="normal" color="grey800">
            {itemValue(value, field.field)}
          </Text.Normal>
        </Table.Cell>
      ))}
      <Table.Cell>
        <Box alignItems="flexEnd">
          <Icon.Medium icon="arrow-right" color="grey600" />
        </Box>
      </Table.Cell>
    </Table.Row.Router>
  )
}

export default observer(TableBodyRowComponent)
